import { render } from "./Transports.vue?vue&type=template&id=566feff8"
import script from "./Transports.vue?vue&type=script&lang=js"
export * from "./Transports.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__